import React, { useEffect, useState } from 'react';
import { Terminal } from 'lucide-react';
import { skills } from '../../data/skills';

const SkillsTerminal = () => {
  const [displayText, setDisplayText] = useState('');

  useEffect(() => {
    const text = skills.join(", ");
    let currentIndex = 0;
    
    const interval = setInterval(() => {
      if (currentIndex <= text.length) {
        setDisplayText(text.substring(0, currentIndex) + '|');
        currentIndex++;
      } else {
        clearInterval(interval);
        setDisplayText(text);
      }
    }, 50);

    return () => clearInterval(interval);
  }, []);

  return (
    <section className="bg-black/70 border border-green-500 p-3 md:p-5 mt-4 md:mt-8 mx-4 md:mx-0">
      <div className="border-b border-green-500 pb-2 mb-2">
        <span className="text-green-500 text-sm md:text-base">
          <Terminal className="inline mr-2 w-4 h-4 md:w-5 md:h-5" />skills.sh
        </span>
      </div>
      <div className="text-green-500 text-sm md:text-base">
        <span>$ ./view_skills.sh</span>
      </div>
      <div className="mt-2 text-green-500 text-sm md:text-base leading-relaxed">
        {displayText}
      </div>
    </section>
  );
};


export default SkillsTerminal;